const hiMessages = {
  /* 01.General */
  "chat.end": "बातचीत समाप्त करें",
  "chat.endall": "बातचीत बंद करें",
  "chat.cancel": "रद्द करें",
  "chat.cookie":
    "यह डिजिटल सहायक यह सुनिश्चित करने के लिए कुकीज़ का उपयोग करता है कि आपको सबसे अच्छा अनुभव मिले",
  "chat.learn": "और अधिक जानें",
  "chat.minimize": "छोटा करें",
  "chat.hide": "बंद करें",
  "chat.hidebot.text": "करीब 15 मिनट के लिए अवतार गायब कर देगा।",
  "chat.hidebot": "बोट बंद करें",
  "chat.restart": "पुनर्प्रारंभ करें",
  "switch.language": "भाषा बदलें",
  "switch.property": "संपत्ति बदले",
  "restart.converstation": "वार्तालाप को पुनरारंभ करें",
  "chat.endtext": "क्या आप वाकई वर्तमान चैट को समाप्त करना चाहते हैं?",
  "check.availabity": "उपलब्धता जांचें",
  "check.availabity.submit": "प्रस्तुत करना",
  "check.availabity.cancel": "रद्द करें",
  "check.availabity.adults": "वयस्कों ",
  "check.availabity.children": "बच्चे",
  "check.availabity.child.age": "आयु - बच्चा",
  "feedback.leave": "प्रतिक्रिया दें",
  "feedback.leave.message": "संदेश छोड़ें",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "केस सबमिट करें",
  "caseform.system": "सिस्टम",
  "caseform.loading.systems": "सिस्टम लोड हो रहे हैं...",
  "caseform.select.system": "सिस्टम चुनें",
  "caseform.error.systems": "सिस्टम लोड करने में त्रुटि",
  "caseform.scenario": "परिदृश्य",
  "caseform.loading.scenarios": "परिदृश्य लोड हो रहे हैं...",
  "caseform.select.scenario": "परिदृश्य चुनें",
  "caseform.error.scenarios": "परिदृश्य लोड करने में त्रुटि",
  "caseform.topic": "विषय",
  "caseform.loading.topics": "विषय लोड हो रहे हैं...",
  "caseform.select.topic": "विषय चुनें",
  "caseform.error.topics": "विषय लोड करने में त्रुटि",
  "caseform.productArea": "Product Areas",
  "caseform.loading.productAreas": "Loading product areas...",
  "caseform.select.productArea": "Select Product Area",
  "caseform.error.productAreas": "Error loading product areas",
  "caseform.module": "Modules",
  "caseform.loading.modules": "Loading modules...",
  "caseform.select.module": "Select Module",
  "caseform.error.modules": "Error loading modules",
  "caseform.feature": "Features",
  "caseform.loading.features": "Loading features...",
  "caseform.select.feature": "Select Feature",
  "caseform.error.features": "Error loading features",
  "caseform.subject": "विषय",
  "caseform.description": "विवरण",
  "caseform.attachments": "संलग्नक",
  "caseform.attachments.remove": "हटाएं",
  "caseform.submit": "सबमिट करें",
  "caseform.cancel": "रद्द करें",
  "caseform.success.title": "केस बनाया गया",
  "caseform.success.message": "आपका केस सफलतापूर्वक बनाया गया है।",
  "caseform.success.caseNumber": "केस नंबर:",
  "caseform.success.transferToLiveAgent":
    "आपको एक लाइव एजेंट से जोड़ा जा रहा है।",
  "caseform.success.newChatWindowRightSide":
    "आपके ब्राउज़र के दाईं ओर एक नई चैट विंडो खुलेगी।",
  "caseform.success.ok": "ठीक है",
  "simpleaction.title": "एक क्रिया चुनें",
  "simpleaction.body":
    "कृपया निम्नलिखित विकल्पों में से एक का चयन करें:{br}{b}एक केस बनाएं{/b} एक समर्थन अनुरोध जमा करने के लिए, या {b}एक चैट शुरू करें{/b} अभी एक एजेंट के साथ जुड़ने के लिए।",
  "simpleaction.startchat": "एक चैट शुरू करें",
  "simpleaction.createcase": "एक केस बनाएं",
  "caseform.error.generic": "केस निर्माण में त्रुटि।",
  "caseform.error.generic.message":
    "आपके केस को बनाते समय एक त्रुटि हुई। कृपया बाद में पुन: प्रयास करें।",
};
export default hiMessages;
